export const rangoFechas = {
  desde: "Desde",
  hasta: "Hasta",
  etiqueta: "Fechas",
  quitar: "Quitar fechas",
  titulo: "Elegir fechas",
  elegirInicio: "Toca el primer día",
  elegirFin: "Ahora toca el último día",
  dias: "día | días",
  anterior: "Mes anterior",
  siguiente: "Mes siguiente",
  cancelar: "Cancelar",
  aplicar: "Aplicar",
};
